import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";

import PdfRpDlg from "../fkn/pdf_rp_dlg";
import Dt_Cal from "../../../lib/ui/dt_cal";
import {format, subDays} from "date-fns";
import * as utils from "../../../assets/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MxRpDlg from "../fkn/mx_rp_dlg";
import ddo from "../../../ddo";

class Bet_Dlg extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_fd = React.createRef();
    this.dt_td = React.createRef();

    this.pos = props.store.pos;
    this.state = {};
    this.state.lsa = [];
    this.state.lso = {};
    //this.state.lro = props.lro;
    this.state.tya = [
                {id: '01', text: 'Summerad'},
                {id: '02', text: 'Dag för dag'}
            ];
    this.state.aa = [];
    this.state.cols = {};
    this.state.lrwrk = false;
    //context.posrend = this;
    this.state.today = new Date();
    this.state.favd = ddo.cache.avd;
    this.state.tavd = ddo.cache.avd;
    this.state.fdat = "";
    this.state.tdat = "";
    this.state.pdf = 0;
    this.state.pdf_content = null;
      this.state.mx = {};
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.dlg_init();
  }
  dlg_init() {
      var dat = this.state.today;
      dat = subDays(dat, 1);
      var dts = format(dat, "yyyy-MM-dd");
      var state = this.state;
      state.fdat = dts;
      state.tdat = dts;
      state.favd = ddo.cache.avd;
      state.tavd = ddo.cache.avd;
      state.loading = 0;
    this.setState(state);
  }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        return css;
    }
    body_style() {
        var css = {};
        css.display = "";
        if( this.state.loading == 1 ) css.display = "none";
        return css;
    }
  dt_fdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ fdat: dts });
  }
  dt_tdat(e) {
      //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ tdat: dts });
  }
  oneday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_td.current.updateDt(this.state.fdat);
  }
  addday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateAdd();
    this.dt_td.current.updateAdd();
  }
  subday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateSub();
    this.dt_td.current.updateSub();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    tab_head(tabid) {
        var css = {};
        css.background = "#fff";
        css.color = "#000";
        if(this.state.tabval === tabid) {
            css.background = "#080";
            css.color = "#fff";
        }
        return css;
    }
  change_fdat(e) {
    //let cdat = this.state.seldate;
    let cdat = e.value;
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1).toString().tonum(2) + "-" + cdat.getDate().toString().tonum(2);
    this.setState({fromdate: e.value, fdat: formatted_date});
  }
  change_tdat(e) {
    //let cdat = this.state.seldate;
    let cdat = e.value;
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1).toString().tonum(2) + "-" + cdat.getDate().toString().tonum(2);
    this.setState({todate: e.value, tdat: formatted_date});
  }
  change_favd(e) {
    //let cdat = this.state.seldate;
    let avd = e.target.value;
    this.setState({favd: avd});
  }
  change_tavd(e) {
    //let cdat = this.state.seldate;
    let avd = e.target.value;
    this.setState({tavd: avd});
  }
  pdf_done (ret) {
    this.setState({loading: 0, pdf: 0, pdf_content: null });
  }

    rp_prn() {
        var self = this;
        var prm = {};
     	prm.req = "pos.pos_rp_02.rp_stat_bet";
   		prm.fdat = this.state.fdat;
   		prm.tdat = this.state.tdat;
   		prm.favd = ddo.cache.avd;
   		prm.tavd = ddo.cache.avd;
        //alert(JSON.stringify(prm));

        //gda.wndLoading("Hämtar");
        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));

            //var uri = "data:application/pdf;base64," + ret.pdf;
            self.setState({pdf: 1, pdf_content: ret.pdf });
            //self.syncCols("lsTable");
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
            //gda.wndError(txt);
        });
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    handleClose = () => {
		this.props.ctx.setState({ rptyp: "" });
	};

  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }

    render() {
        if(!this.props.show) return "";

        //alert(this.props.ctx.state.lro);

        var title = this.props.title;
        if(!title) title = "DAGLIGRAPPORT";
        //if(props.kro) alert(props.kro.krr00.kid);

        var html =
            <div className="mx_base">
                { this.props.backdrop ? <div className="m2_backdrop" /> : null }
                <div className="m2_dlg mx_80 flex-col" style={ this.dlg_style() }>
                    <div className="mx_head mx_bg flex-row flex-space-between">
                        <div className="flex-col flex">
                            <div>BETALMEDELS STATISTIK</div>
                        </div>
                        <div className="white-icon-close" onClick={() => this.handleClose() }>X</div>
                    </div>
                    { this.state.loading ? <div className="mx_content flex align-items-center justify-content-center"><FontAwesomeIcon icon="spinner" spin size="3x" fixed /></div> :
                        null }
                    <div className="mx_content flex" style={ this.body_style() }>
                        <div className="flex-row px-2">
                            <div className="flex-col flex">
                                <div>Start</div>
                            </div>
                            <div className="flex-col flex">
                                <div></div>
                            </div>
                            <div className="flex-col w50">
                                <div>Ändra</div>
                            </div>
                        </div>
                        <div className="divider_orange"></div>

                        <div className="mx_body flex">

                            <div className="flex-row">
                                <div className="flex-col">
                                    <span>&nbsp;</span>
                                    <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                                </div>
                                <div className="flex-col">
                                    <span>Från</span>
                                    <Dt_Cal startdatum="2020-02-01" rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
                                </div>
                                <div className="flex-col">
                                    <span>&nbsp;</span>
                                    <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
                                </div>
                                <div className="flex-col">
                                    <span>Till</span>
                                    <Dt_Cal startdatum="2020-02-01" rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
                                </div>
                                <div className="flex-col">
                                    <span>&nbsp;</span>
                                    <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
                                </div>
                            </div>

                            <div className="flex-row hide">
                                <div className="flex-col">
                                    <span>Från</span>
                                    <select className="form-control input-rp-01 w250" placeholder="Från avdelning" onChange={(e) => this.change_favd(e)}>
                                        { this.pos.deps.map((row, key) =>
                                            <option key={key} value={row.avd}>{row.avd} - { utils.toLang(row.text) }</option>
                                        )}
                                    </select>
                                </div>
                                <div className="flex-col">
                                    <span>Till</span>
                                    <select className="form-control input-rp-01 w250" placeholder="Till avdelning" onChange={(e) => this.change_tavd(e)}>
                                        { this.pos.deps.map((row, key) =>
                                            <option key={key} value={row.avd}>{row.avd} - { utils.toLang(row.text) }</option>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div className="flex-row">
                                <div className="flex-col">
                                    <span>Typ</span>
                                    <select className="form-control input-rp-01 w250" placeholder="Typ" onChange={(e) => this.change_typ(e)}>
                                        { this.state.tya.map((row, key) =>
                                            <option key={key} value={row.id}>{row.text}</option>
                                        )}
                                    </select>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="mx_foot flex-row">
                        <div className="flex-row flex">
                            <div className="btn-rp" onClick={() => this.handleClose() } >
                                <div>STÄNG</div>
                                <div><FontAwesomeIcon icon="times" size="2x" /></div>
                            </div>
                            <div className="btn-rp hide" onClick={() => this.rp_xl() } >
                                <div>EXCEL EXPORT</div>
                                <div><FontAwesomeIcon icon="download" size="2x" /></div>
                            </div>
                        </div>
                        <div className="flex-row">
                            <div className="btn-rp" onClick={() => this.rp_mx() } >
                                <div>EPOST</div>
                                <div><FontAwesomeIcon icon="at" size="2x" /></div>
                            </div>
                            <div className="btn-rp" onClick={() => this.rp_prn() } >
                                <div>SKRIV UT</div>
                                <div><FontAwesomeIcon icon="print" size="2x" /></div>
                            </div>
                        </div>
                    </div>

                </div>
                <MxRpDlg mx={this.state.mx} done={(ret) => this.mx_done(ret)} backdrop={true}/>
                <PdfRpDlg show={this.state.pdf} pdf={this.state.pdf_content} done={(ret) => this.pdf_done(ret)} backdrop={true}/>
            </div>
        ;
        return html;
    };
}

export default Bet_Dlg;